import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

function SponsorsSection() {
  const { t } = useTranslation();
  const sponsorCards = [
    {
      icon: "fas fa-eye",
      title: t("sponsors.criteria1.title"),
      description: t("sponsors.criteria1.description"),
    },
    {
      icon: "fas fa-handshake",
      title: t("sponsors.criteria2.title"),
      description: t("sponsors.criteria2.description"),
    },
    {
      icon: "fas fa-leaf",
      title: t("sponsors.criteria3.title"),
      description: t("sponsors.criteria3.description"),
    },
    {
      icon: "fas fa-star",
      title: t("sponsors.criteria4.title"),
      description: t("sponsors.criteria4.description"),
    },
  ];

  const navigate = useNavigate();

  const seeMore = () => {
    navigate("/sponsors");
    window.scrollTo(0, 0);
  };

  return (
    <section className="pt-12 pb-12 bg-slate-50/50 dark:bg-slate-900 transition-colors relative z-10" id="sponsors-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header Section */}
        <div className="mb-8 text-center">
          <h2 className="text-4xl md:text-5xl mb-5 text-primary dark:text-primary-light relative inline-block">
            {t("sponsors.title")}
            {/* Underline decoration */}
            <div className="absolute -bottom-2.5 left-1/2 transform -translate-x-1/2 w-15 h-0.5 bg-primary dark:bg-primary-light rounded-sm" />
          </h2>
          <p className="text-slate-600 dark:text-slate-400 mt-4 text-lg max-w-3xl mx-auto">
            {t("sponsors.description")}
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          {sponsorCards.map((item, index) => (
            <div
              key={index}
              className="bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 shadow-sm p-6 hover:shadow-md transition-all duration-200"
            >
              <div className="flex flex-col items-center text-center space-y-4">
                {/* Icon */}
                <div className="flex-shrink-0 w-16 h-16 rounded-full bg-primary/10 dark:bg-primary-light/20 flex items-center justify-center">
                  <i className={`${item.icon} text-primary dark:text-primary-light text-2xl`}></i>
                </div>
                
                {/* Content */}
                <div className="space-y-2">
                  <h3 className="text-lg font-semibold text-slate-900 dark:text-slate-100">
                    {item.title}
                  </h3>
                  <p className="text-sm text-slate-600 dark:text-slate-400 leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Button */}
        <div className="flex justify-center">
          <button
            onClick={seeMore}
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary dark:bg-primary-light text-white text-sm font-medium rounded-md hover:bg-primary-dark dark:hover:bg-primary transition-colors focus:outline-none focus:ring-2 focus:ring-primary/20 dark:focus:ring-primary-light/20 shadow-sm hover:shadow-md"
          >
            {t("button.see_more")}
            <i className="fas fa-arrow-right"></i>
          </button>
        </div>
      </div>
    </section>
  );
}

export default SponsorsSection;
